import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { BaseMenu, BreadCrumb, CustomTable, SnackSimple } from "../../../../../../components"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { FiltersDrawer } from "../../../../../../components/filtersDrawer"
import { icons } from "../../../../../../utils/icons"
import { useNavigate } from "react-router-dom"
import { useBody } from "./body"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { ModelDownloadButtons } from "../../../../../../components/donwloadFiles/model"


const Catalog = () => {
  const styles = useStyles()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const body = useBody()
  const query = body.filterCatalog?.query
  return (
    <Box sx={styles.container}>
      <Box sx={styles.subContainer}>

        <BreadCrumb
          removeBreadcrumb={['report-folio']}
        />

        <FiltersDrawer cleanFilter={body.cleanFilter} count={body.counter} right={0} top={0}>
          <Box sx={styles.section}>
            <DinamicForm errors={body.errors} input={Object.values(body.input)} values={body.filterData} onChange={body.onChange} filter={true} legacyErrors />
          </Box>
        </FiltersDrawer>

        <Box sx={styles.header}>
          <Typography variant="title_grey_big">{t('catalog.title')}</Typography>

          <Box sx={styles.flex}>
            {!!body.counter && <IconButton
              sx={(styles.clean, (body.counter || 0) > 0 ? null : styles.hide)}
              onClick={() => {
                body.cleanFilter()
              }}
            >
              {icons('clean')}
            </IconButton>
            }
            <SnackSimple
              close={body.downloadMain.closeOpenSnakbar}
              open={body.downloadMain.openSnackbar.open}
              type={body.downloadMain.openSnackbar.type}
              message={body.downloadMain.openSnackbar.message}
            />

            <ModelDownloadButtons
              csv={body.downloadMain.downloadCSV}
              pdf={body.downloadMain.downloadPDF}
              word={body.downloadMain.downloadWORD}
              disableCSV={body.downloadMain.download?.excel}
              disablePDF={body.downloadMain.download?.pdf}
              disableWORD={body.downloadMain.download?.word}
            /* styleType 
            disableTypes={['word']}  */
            />
            <Tooltip title={t('ToolTips.create')}>
              <IconButton
                sx={styles.clean}
                onClick={() => {
                  navigate(`/dashboard/report-folio/catalog/create`)
                }}
              >
                {icons('add')}
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <BaseMenu
          sx={[styles.baseMenu, body.settingData?.positionxy ?? { left: '-200%' }]}
          anchorEl={body.settingData?.e?.target ?? null}
          setAnchorEl={body.closeMenu}
          menuItems={body.menu}
          click={(item) => {
            body.optionMenu({ item })
          }}
        />

        <CustomTable
          name="Informe General"
          serverSidePagination={{ page: body.paginationModel.page + 1, size: body.paginationModel.pageSize, totalPages: body.totalPages }}
          handleChange={(page: number, pageSize: number) => {
            body.handlePagination({ page, pageSize })
          }}
          order={
            query?.sort && {
              count: query?.sort?.count,
              key: query?.sort?.field,
              order: query?.sort?.sort,
            }
          }
          sortable={(field, sort, count) => {
            body.filterCatalog.sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
          }}
          column={body.columnMain}
          loader={body.loading.table}
          row={body.table.row}
          selected={-1}
        />
      </Box>

      <SimpleModal
        open={body.modalDelete?.open ?? false}
        close={() => {
          body.closeModalDelete()
        }}
        title={body.modalDelete?.title}
        description={body.modalDelete?.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        back={() => {
          body.closeModalDelete()
        }}
        next={() => {
          if (body.modalDelete?.confirm) {
            body.modalDelete.confirm()
          }
        }}
      />
      <SnackSimple
        close={body.closeSnackbar}
        open={body.openSnackbar.open}
        type={body.openSnackbar.type}
        message={body.openSnackbar.message}
      />
    </Box>
  )
}

export { Catalog }
